// src/sentry.ts
// Browser-side Sentry initialisation for the SPA. Called once from main.tsx
// before the React tree mounts. No-ops when VITE_SENTRY_DSN is unset, so local
// dev and preview builds without a project work unchanged.
//
// VITE_SENTRY_DSN is inlined at build time — pass it on `vite build` /
// `fly deploy --build-arg VITE_SENTRY_DSN=...` (see fly.toml [build.args]).

import * as Sentry from '@sentry/react';

export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE as string | undefined,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // Performance tracing for page loads / navigations.
    tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? '0.1'),
    // Session Replay: record a small sample of sessions, and every session
    // in which an error occurs.
    replaysSessionSampleRate: Number(import.meta.env.VITE_SENTRY_REPLAY_SAMPLE_RATE ?? '0'),
    replaysOnErrorSampleRate: 1.0,
  });
}

export { Sentry };
